import type { ILocationRepository } from '../repositories/ILocationRepository.js';
import type { LocationEntity } from '../entities/LocationEntity.js';

interface Deps { locationRepository: ILocationRepository; }

export function createGetLocationByIdUseCase({ locationRepository }: Deps) {
  return async function getLocationById(id: string): Promise<LocationEntity | null> {
    return locationRepository.getById(id);
  };
}
